// extracted by mini-css-extract-plugin
export var active = "clubsNetwork-module--active--8aa29";
export var clubItem = "clubsNetwork-module--clubItem--66ff1";
export var clubName = "clubsNetwork-module--clubName--3f972";
export var container = "clubsNetwork-module--container--27a9e";
export var content = "clubsNetwork-module--content--45527";
export var fadeInLeft = "clubsNetwork-module--fadeInLeft--64fa7";
export var fadeInRight = "clubsNetwork-module--fadeInRight--9955a";
export var fadeInUp = "clubsNetwork-module--fadeInUp--c9799";
export var greenText = "clubsNetwork-module--greenText--47d87";
export var infoSide = "clubsNetwork-module--infoSide--e4982";
export var logo = "clubsNetwork-module--logo--efcf9";
export var logoWrapper = "clubsNetwork-module--logoWrapper--74a17";
export var near = "clubsNetwork-module--near--62f3e";
export var sliderContainerEdge = "clubsNetwork-module--sliderContainerEdge--6e673";
export var sliderContent = "clubsNetwork-module--sliderContent--5feee";
export var sliderSide = "clubsNetwork-module--sliderSide--02fee";
export var sliderTrack = "clubsNetwork-module--sliderTrack--22d6c";
export var statItem = "clubsNetwork-module--statItem--324b2";
export var statLabel = "clubsNetwork-module--statLabel--1fa78";
export var statValue = "clubsNetwork-module--statValue--928b5";
export var statsRow = "clubsNetwork-module--statsRow--979a4";
export var subtitle = "clubsNetwork-module--subtitle--fa3f2";
export var swiperSlide = "clubsNetwork-module--swiper-slide--9ec8e";
export var swiperSlideActive = "clubsNetwork-module--swiper-slide-active--5dd49";
export var swiperSlideDuplicateActive = "clubsNetwork-module--swiper-slide-duplicate-active--f0dbe";
export var swiperSlideDuplicateNext = "clubsNetwork-module--swiper-slide-duplicate-next--05c02";
export var swiperSlideDuplicatePrev = "clubsNetwork-module--swiper-slide-duplicate-prev--93255";
export var swiperSlideNext = "clubsNetwork-module--swiper-slide-next--5498e";
export var swiperSlidePrev = "clubsNetwork-module--swiper-slide-prev--94fed";
export var title = "clubsNetwork-module--title--1588d";